  export const add_Configuration = async (title, tags, functionID, titleTag, dispatch,configureAction, refreshTable) => {
    let tags_Array = tags.split(",");
    switch (titleTag.title) {
      case "Function":
        await dispatch(
          configureAction.add_functionTag(tags_Array, refreshTable)
        );
        break;
      case "Skill":
        await dispatch(
          configureAction.add_skillTag(tags_Array, refreshTable, functionID)
        );
        break;
      case "Domain":
        await dispatch(configureAction.add_domainTag(tags_Array, refreshTable));
        break;
      case "Role":
        await dispatch(configureAction.add_roleTag(tags_Array, refreshTable));
        break;
      default:
        let array_exist_new = titleTag.tags
          .map(({ name }) => name)
          .concat(tags_Array);
        await dispatch(
          configureAction.add_otherTag(
            titleTag.id,
            array_exist_new,
            refreshTable
          )
        );
        break;
    }
  };